import { render } from "./SuccessStories.vue?vue&type=template&id=977d22c2"
import script from "./SuccessStories.vue?vue&type=script&lang=js"
export * from "./SuccessStories.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__